// packages/content/src/strings/email.ts
import type { StringBank } from '../schema/strings';
export default {
  otpSubject: 'Your {app} code: {otp}',
  otpBody: 'Your sign-in code is {otp}. It expires in {minutes} minutes.\n\nIf you didn’t ask for it, you can ignore this email.',
  reportSubject: '{app}: a new report in {town}',
  reportBody: 'A {kind} was reported in {town}.\n\n{content}\n\nOpen the admin page to review it.',
} as const satisfies StringBank;
